// src/poker/components/LevelsTable.js
import React from "react";
import { clampInt } from "../pokerClock.logic";

const th = { padding: "8px 8px", position: "sticky", top: 0, background: "rgba(0,0,0,0.12)" };
const td = { padding: "8px 8px" };

export default function LevelsTable({
  levels,
  levelIndex,
  onAddLevel,
  onRemoveLevel,
  onSelectLevel,
  onUpdateLevel,
}) {
  return (
    <div className="panel-card" style={{ minWidth: 0 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <div style={{ fontWeight: 800 }}>Struktura blindów</div>
        <div style={{ marginLeft: "auto", display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button className="btn-secondary" type="button" onClick={onAddLevel}>
            + Poziom
          </button>
        </div>
      </div>

      <div
        style={{
          marginTop: 10,
          overflowX: "auto",
          overflowY: "auto",
          maxHeight: 420,
          maxWidth: "100%",
          borderRadius: 12,
        }}
      >
        <table
          style={{
            width: "100%",
            minWidth: 560,
            borderCollapse: "collapse",
            fontSize: 13,
          }}
        >
          <thead>
            <tr style={{ textAlign: "left", opacity: 0.85 }}>
              <th style={th}>#</th>
              <th style={th}>Min</th>
              <th style={th}>SB</th>
              <th style={th}>BB</th>
              <th style={th}>Ante</th>
              <th style={th}></th>
            </tr>
          </thead>

          <tbody>
            {levels.map((lvl, i) => {
              const active = i === levelIndex;
              return (
                <tr
                  key={lvl.id || i}
                  style={{
                    borderTop: "1px solid rgba(255,255,255,0.14)",
                    background: active ? "rgba(255,165,0,0.10)" : "transparent",
                    cursor: "pointer",
                  }}
                  onClick={() => onSelectLevel(i)}
                >
                  <td style={td}>
                    <b>{i + 1}</b>
                  </td>

                  <td style={td}>
                    <input
                      className="input"
                      type="number"
                      value={lvl.minutes}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => onUpdateLevel(i, { minutes: clampInt(e.target.value, 1, 120, lvl.minutes) })}
                      style={{ minWidth: 72 }}
                    />
                  </td>

                  <td style={td}>
                    <input
                      className="input"
                      type="number"
                      value={lvl.sb}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => onUpdateLevel(i, { sb: clampInt(e.target.value, 1, 1000000000, lvl.sb) })}
                      style={{ minWidth: 92 }}
                    />
                  </td>

                  <td style={td}>
                    <input
                      className="input"
                      type="number"
                      value={lvl.bb}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => onUpdateLevel(i, { bb: clampInt(e.target.value, 1, 1000000000, lvl.bb) })}
                      style={{ minWidth: 92 }}
                    />
                  </td>

                  <td style={td}>
                    <input
                      className="input"
                      type="number"
                      value={lvl.ante || 0}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) =>
                        onUpdateLevel(i, { ante: clampInt(e.target.value, 0, 1000000000, lvl.ante || 0) })
                      }
                      style={{ minWidth: 92 }}
                    />
                  </td>

                  <td style={td}>
                    <button
                      className="btn-secondary"
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        onRemoveLevel(i);
                      }}
                      title="Usuń poziom"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: 10, fontSize: 12, opacity: 0.85 }}>
        Wskazówka: klik w wiersz ustawia aktywny poziom i resetuje czas tego poziomu.
      </div>
    </div>
  );
}
